<template>
  <div v-if="currentUser.superAdmin">
    <v-data-table
        :headers="headers"
        :items="packages"
        :loading="loading"
        hide-default-footer
        disable-pagination
        class="elevation-1"
    >
      <template v-slot:item.id="{ item }">
        <v-menu :close-on-content-click=false bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on"
            >mdi-focus-field-horizontal
            </v-icon>
          </template>
          <v-list dense style="max-height: 500px" class="overflow-y-auto">
            <v-list-item >
              <v-list-item-title>{{ item.id }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.image="{ item }">
        <v-img
            :src="item.imagePath"
            contain
            max-height="80"
            max-width="80"
            @error="
            item.bannerUrl = 'media/error/imageNotFound.png'
          "
        ></v-img>
      </template>

      <template v-slot:header.add="">
        <router-link :to="{ name: 'PackageCreate' }">
          <v-avatar color="teal" size="26" rounded>
            <v-icon dark>mdi-plus</v-icon>
          </v-avatar>
        </router-link>
      </template>
      <template v-slot:item.created="{ item }">
        {{ new Date(item.created).toLocaleString() }}
      </template>
      <template v-slot:item.priceAndCurrency="{ item }">
        {{
          item.catalogItemPrices != null && item.catalogItemPrices.length > 0 ? item.catalogItemPrices[0].price + " " + item.catalogItemPrices[0].currency : ""
        }}
      </template>
      <template v-slot:item.installmentDuration="{ item }">
        {{
          item.installmentDurationInDays != null ? item.installmentDurationInDays === 365 ? "YEARLY" : item.installmentDurationInDays === 30 ? "MONTHLY" : "" : ""
        }}
      </template>
      <template v-slot:item.permissions="{ item }">
        {{ item.permissions.length > 0 ? item.permissions[0].permissionName : "" }}
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-icon v-if="item.permissions.length > 1" small class="mr-2" v-on="on"
            >mdi-dots-horizontal
            </v-icon>
          </template>
          <v-list dense style="max-height: 500px" class="overflow-y-auto">
            <v-list-item v-for="(item, i) in item.permissions" :key="i">
              <v-list-item-title>{{ item.externalId }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-avatar color="teal" size="26" rounded>
          <router-link
              :to="{
              name: 'PackageEdit',
              params: { packageId: item.id }
            }"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </router-link>
        </v-avatar>
      </template>
      <template v-slot:item.add="{ item }">
        <v-avatar color="red darken-4" size="26" rounded>
          <v-icon dark @click="delRecord(item)">mdi-delete</v-icon>
        </v-avatar>
      </template>
    </v-data-table>
    <ConfirmDialog ref="confirm"/>
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import moment from "moment";
import MembershipApiService from "@/core/services/api.service.membership";
import {mapGetters} from "vuex";
import ConfirmDialog from "@/view/pages/ConfirmDialog";

export default {
  name: "packages",
  computed: {
    ...mapGetters(["currentUser"]),
    headers() {
      return [
        {text: "Id", align: "start", value: "id", sortable: false},
        {text: this.$i18n.t('common.name'), value: "name", sortable: false},
        {text: this.$i18n.t('common.description'), value: "description", sortable: false},
        {text: this.$i18n.t('common.upsellLevel'), value: "upsellLevel", sortable: false},
        {text: this.$i18n.t('commonTable.price'), value: "priceAndCurrency", sortable: false, width: "10%"},
        {text: this.$i18n.t('common.active'), value: "active", sortable: false},
        {text: this.$i18n.t('common.installmentDuration'), value: "installmentDuration", sortable: false},
        {text: this.$i18n.t('common.oobleeCoins'), value: "oobleeCoins", sortable: false},
        {text: this.$i18n.t('common.advertisementOobleeCoins'), value: "advertisementOobleeCoins", sortable: false},
        {text: this.$i18n.t('common.fee'), value: "fee", sortable: false},
        {text: this.$i18n.t('common.permissions'), value: "permissions", sortable: false},
        {text: this.$i18n.t('common.image'), value: "image", sortable: false},
        {text: this.$i18n.t('common.created'), value: "created", sortable: false, width: "10%"},
        {text: "", value: "edit", width: "5%", sortable: false},
        {text: "", value: "add", width: "5%", sortable: false}
      ]
    }
  },
  data() {
    return {
      packages: [],
      loading: false,
      membershipApiInitiated: false,
      loader: null,
      errors: []
    };
  },
  async created() {
    if (!this.currentUser.superAdmin) return;
    this.loading = true;
    this.$log.debug("await init memb service - start");
    await MembershipApiService.init();
    this.$log.debug("await init memb service - end");
    this.membershipApiInitiated = true;
    this.retrievePackages();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: "Packages"}]);
  },
  components: {
    ConfirmDialog
  },
  methods: {

    async delRecord(item) {
      if (
          await this.$refs.confirm.open(
              "Confirm",
              "Are you sure you want to delete membership package with id: " + item.id + " ?"
          )
      ) {
        this.deletePackage(item);
      }
    },
    deletePackage(item) {
      this.loading = true;
      if (item.id != null) {
        MembershipApiService.put(`/CatalogItems/Deactivate?id=${item.id}`)
            .then(response => {
              this.$log.debug("Package deactivated: ", item.id);
              this.$log.debug("Response: ", response);
            })
            .catch(error => {
              this.$log.error("Error: ", error);
              this.errored = true;
            })
            .finally(() => (this.retrievePackages(), this.loading = false));
      }
    },
    parseDate(timestamp) {
      return moment
          .utc(timestamp)
          .local()
          .format("yyyy-MM-DD HH:mm:ss");
    },
    retrievePackages() {
      let params = {};
      return new Promise(resolve => {
        this.loading = true;
        MembershipApiService.query("/CatalogItems/GetAllBundles",
            params
        ).then(response => {
          // JSON responses are automatically parsed.
          this.$log.debug("packages response: ", response.data);
          this.packages = response.data;
          this.loading = false;
          resolve();
        });
      });
    }
  }
};


</script>
<style>
.v-data-table.v-data-table.v-data-table >>> td {
  font-size: 16px;
}

.v-icon.v-icon {
  font-size: 24px !important;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}

tbody tr {
  width: 100%;
}

.filter {
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  background-color: aliceblue;
  border: 1px solid brown;
}

.search {
  display: flex;
  justify-content: space-around;
  padding: 20px;
}

.search-item {
  justify-content: center;
  display: flex;
}

</style>
